const de = {
  nav: {
    services: 'Services',
    about: 'Über uns',
    references: 'Projekte',
    contact: 'Kontakt',
    cta: 'Hola! →',
  },
  hero: {
    kicker: 'Studio für Design & Text',
    tagline: 'Weil du mit uns Zeit für die wichtigen Dinge hast',
    cta1: 'Lass uns reden →',
    cta2: 'Unsere Services',
    marquee: 'good design and text for you from buenas  ·  ',
  },
  intro: {
    kicker: '#bettertogether',
    h2line1: 'Studio für Design & Text',
    h2line2: '',
    subheadline: 'good. better. buenas.',
    p1: 'Wir sind Eva · Grafikdesignerin, Christina · Texterin und Agustín · IT-Guru.',
    p2: 'Mit einem Team an erfahrenen Tech- und Online-Marketing-Experten. Wir lieben Design, Worte und Technologien. Die digitale Welt und das analoge Leben. Wir schreiben verkaufsstarke Texte, gestalten und programmieren umwerfendes Brand- und Webdesign, Social Media Content, Ads und Printprodukte. Für alle, die das Besondere suchen.',
    p3: '',
    button: 'Mehr über uns →',
  },
  services: {
    kicker: '#buenasideas',
    h2: 'Was wir machen',
    intro:
      'Wir verbinden Grafikdesign, Text und Technologie. Gemeinsam schaffen wir außergewöhnliche Marken- und Kundenerlebnisse. Wir entwickeln, gestalten und programmieren digitale und analoge Produkte und Plattformen, die auch noch richtig gut aussehen. Vom klassischen Printmagazin über modernes Webdesign bis zur spezifischen Software – individuell, kreativ und professionell.',
    col1: {
      title: 'Grafik & Design',
      items: [
        'Corporate Identity',
        'Corporate Design',
        'Logo Design',
        'Web, App & Screen Design',
        'Print Design & Layout',
        'Magazine & Broschüren',
        'Ad & Content Design',
        'Verpackungsdesign',
      ],
      link: 'Mehr erfahren →',
    },
    col2: {
      title: 'Texte & Worte',
      items: [
        'Corporate Wording',
        'Website & App Texte',
        'Storytelling',
        'Werbe- & Magazintexte',
        'Ad- & Kampagnentexte',
        'Content Marketing',
        'Slogans & Claims',
        'SEO-Texte',
      ],
      link: 'Mehr erfahren →',
    },
    col3: {
      title: 'Software & Entwicklung',
      items: [
        'Mobile, Web & App Development',
        'Digitale Produkte & Plattformen',
        'Software Development',
        'Responsive Design',
        'Landing Pages',
        'Corporate Websites',
        'Schnittstellen & Datenbanken',
        'E-Commerce & Onlineshops',
      ],
      link: 'Mehr erfahren →',
    },
    panel:
      'Markenentwicklung · Branding · Packaging · Print und Digital · Webdesign · KI & Software · Social Media · Content Marketing · Paid Advertising',
  },
  team: {
    kicker: '#buenaspersonas',
    h2: 'Wer wir sind',
    moreLabel: 'mehr erfahren',
    lessLabel: 'weniger',
    intro:
      'We are young, wild and free – okay, so jung sind wir auch nicht mehr. Aber wir fühlen uns zumindest noch so. Wir sind eine Gruppe von Kreativen, die lieben was sie tun. Die etwas andere Agentur, wo jede:r auf seinem Gebiet ein Experte ist. Wir sind mutig, motiviert und erfahren. Analoge und digitale Creatives. Liebenswerte Nerds. Buenas Personas. Du kannst uns einzeln oder gemeinsam als Team beauftragen. Online und persönlich.',
    eva: {
      role: 'Grafikdesignerin',
      bio: 'Wenn du ein umwerfendes Erscheinungsbild mit Logo und Farbkonzept benötigst: Eva ist unsere Grafik- und Designexpertin. Sie entwickelt und verbessert dein Corporate- und Webdesign, deine Print- und Onlinemedien sowie dein Verpackungsdesign. Sie liebt saubere, reduzierte und elegante Designs und hat ein besonders gutes Auge für Details.',
      more: 'Eva ist die Zwillingsschwester von Christina, mit ihrer Jugendliebe verheiratet und wohnt mit ihrer Katze „Happy" in Hard am schönen Bodensee. Reisen gehört zu ihren Leidenschaften genauso wie Padel, Yoga, Kunst und Kultur. Sie kann besonders gut zuhören und auf Menschen eingehen. Dadurch zaubert sie einzigartige Designs, die genau zu dir und deinen Produkten und Technologien passen.',
      badge: 'good design by eva',
      quote: '»Good design is as little design as possible«',
    },
    christina: {
      role: 'Texterin',
      bio: 'Wenn dir die Worte fehlen und du inspirierende, authentische Texte brauchst: Christina ist ausgebildete Journalistin und Texterin. Sie arbeitet seit über 15 Jahren in der Marketing- und Kommunikationsbranche und hat sich vor mehr als 5 Jahren selbstständig gemacht. Sie schreibt Texte und Konzepte, die bewegen und brennt für deine Geschichten.',
      more: 'Christina ist eine kreative Denkerin, Reisende und ein über den Tellerrand schauender Mensch. Die Wahl-Andorranerin ist humorvoll, gelassen und ein bisschen #crazy. Sie mag die südländische Lebensart, mediterranes Essen, aber auch die österreichische Gemütlichkeit. Sie bewegt sich viel – beim Padel, Yoga, Wandern oder Skifahren. Dabei findet sie Inspiration und Ideen fürs Schreiben.',
      badge: 'good text by christina',
      quote: '»Writing is magic made visible«',
    },
    agustin: {
      role: 'Software-Entwickler',
      bio: 'Wenn du eine Website oder Software brauchst: Agustín ist unser Senior Full-Stack Developer. Er kümmert sich um dein Back- wie Frontend und beherrscht KI-Tools wie alle Programmiersprachen. Außerdem ist er Experte für Cyber Security. In seiner grafischen Erstausbildung hat er gelernt, worauf es beim Design und der Usability ankommt.',
      more: 'Agus kennt keine Probleme, sondern denkt immer in Lösungen. Er ist Argentinier und Spanier, lebt in Andorra und wenn er nicht mit unseren anderen Developern am Coden ist, findet man ihn meist auf dem Rennrad oder Padelplatz. Er liebt die einfachen Dinge des Lebens: Sport, Pizza, Pasta, Ice Cream, Kaffee, Sonne, Cumbia und natürlich das Nationalgetränk der Argentinier, seinen Mate.',
      badge: 'good solutions by agus',
      quote: "»Don't look for mistakes, look for solutions«",
    },
    belowCards:
      '... und unser Team aus erfahrenen <strong>Tech-Guys</strong> und <strong>Online-Marketing-Experten</strong>, verteilt auf der ganzen Welt. Online, aber immer persönlich.',
  },
  quote: {
    text: '»Es gibt immer eine Lösung. Finde eine, erschaffe eine oder frag andere nach einer.«',
    author: '— Tom Bilyeu',
    cta: 'Lass uns deine Lösung finden →',
  },
  referenzen: {
    kicker: '#buenasprojects',
    h2: 'Mit wem wir arbeiten',
    intro:
      'Wir arbeiten mit Unternehmen, Brands, Hotels, Selbstständigen und Agenturen aus verschiedensten Bereichen zusammen. Wir denken nicht in Schubladen, sondern sind offen für Neues. Aber auch für Bewährtes, disruptive Ideen und nachhaltige Gedanken. Ganz nach dem Motto: Kannst du es dir vorstellen, kannst du es auch machen. Wir freuen uns auf neue Kooperationen, Projekte, mutige Ideen und Menschen, die Lust haben, gemeinsam etwas Besonderes zu schaffen.',
    moreLink: 'Mehr Projekte',
    lessLink: 'Weniger anzeigen',
    badge: 'Mit Winder&Wild',
    placeholder:
      "Unsere Referenzen und Projekte folgen in Kürze. Bald gibt's auch mehr. (Spoiler: Es wird ziemlich BUENAS.)",
    projects: [
      {
        name: 'Hotel Birkenhof · Oberstaufen, Allgäu',
        category: 'Brand Design · Webdesign · Webtexte · Wording · Newsletter',
      },
      {
        name: 'Hotel Helvetia · Lindau, Bodensee',
        category: 'Brand Design · Wording · Merchandising · Broschüre · Texte',
      },
      {
        name: 'Physiomed · Eislingen',
        category: 'Brand Design · Logo Design · Geschäftsausstattung',
      },
      { name: 'Studio Mint · Maria Jussel', category: 'Markenstimme · Storytelling · Webtexte' },
      {
        name: 'Damüls Faschina Tourismus',
        category: 'Magazinreihe · Interviews · Texte · Storytelling',
      },
      {
        name: 'Jean & Jacques Eismanufaktur',
        category: 'Branding · Design · Packaging · Wording · Webtexte',
      },
    ],
  },
  twinPower: {
    kicker: '#goodenergy',
    h2: 'Warum Buenas?',
    text: 'Weil „Buenas" mehr ist als ein Gruß. Es steht für gute Energie, gute Gespräche und gute Zusammenarbeit. Genau so arbeiten wir. Eva, Christina, Agustín und unser Team. Kreative Köpfe mit einer gemeinsamen Vision: Wir unterstützen Unternehmen mit guten Ideen, gutem Design und gutem Text. Für starke Marken, die eine einzigartige Stimme haben.',
    button: 'Hola! Schreib uns →',
  },
  newsletter: {
    kicker: '#goodnewsonly',
    h2: 'Das Beste kommt per Mail',
    subtext1: 'Nur gute Ideen und ein bisschen Buenas-Feeling direkt in dein Postfach.',
    subtext2: 'Wir schreiben über Design, Texte, neue Projekte und Dinge, die uns gerade bewegen.',
    placeholder: 'Deine E-Mail-Adresse',
    button: 'Anmelden →',
    sending: 'Einen Moment...',
    success: 'Super! Du bist dabei. Schau bald in deinem Postfach nach.',
    error: 'Ups – das hat leider nicht geklappt. Versuch es nochmal.',
    privacy: 'Mit der Anmeldung stimmst du unseren',
    privacyLink: 'Datenschutzrichtlinien',
    privacyEnd: 'zu.',
    captchaError: 'Bitte bestätige, dass du kein Roboter bist.',
  },
  kontakt: {
    kicker: '#makeitbuenas',
    h2line1: 'Wie können wir',
    h2line2: 'dir helfen?',
    subtext1: 'Lass uns über deine Marke, deine Idee oder dein Projekt sprechen.',
    subtext2: 'Bei einem Kaffee. Oder einem Call. Oder beidem.',
    bookingKicker: '#bookwithus',
    bookingTitle: 'Call buchen',
    bookingText: 'Wähle einen Termin, der für dich passt, und wir treffen uns auf Zoom.',
    bookingButton: 'Verfügbarkeit ansehen →',
    bookingIframeTitle: 'Call mit Buenas Studio buchen',
    bookingOpenNewTab: 'In neuem Tab öffnen',
    bookingClose: 'Schließen',
    field1: 'Dein Name',
    field2: 'Deine E-Mail',
    field3: 'Dein Unternehmen / Projekt',
    field4: 'Erzähl uns von deiner Idee...',
    button: 'Abschicken →',
    sending: 'Wird gesendet...',
    error: 'Ups – etwas ist schiefgelaufen. Bitte schreib uns direkt an hi@buenas-studio.com.',
    captchaError: 'Bitte bestätige, dass du kein Roboter bist.',
  },
  danke: {
    back: '← Zurück zur Startseite',
    kicker: '#hola!',
    title: 'Danke für deine Nachricht!',
    text: 'Wir haben deine Anfrage erhalten und melden uns so schnell wie möglich bei dir.',
    sub: 'Bis dahin – schau dich ruhig weiter um.',
  },
  impressum: {
    back: '← Zurück zur Startseite',
    title: 'Impressum',
    section1: 'Angaben gemäß gesetzlicher Informationspflicht',
    taxLabel: 'Steuernummer',
    representedBy: 'Vertreten durch',
    responsible: 'Verantwortlich für den Inhalt',
    disclaimer: 'Haftungsausschluss',
    liabilityContent: 'Haftung für Inhalte',
    liabilityContentText:
      'Die Inhalte unserer Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Dienstleister sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.',
    liabilityLinks: 'Haftung für Links',
    liabilityLinksText:
      'Unsere Website enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.',
    copyright: 'Urheberrecht',
    copyrightText:
      'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.',
    dispute: 'Streitschlichtung',
    disputeText:
      'Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.',
  },
  datenschutz: {
    back: '← Zurück zur Startseite',
    title: 'Datenschutzerklärung',
    date: 'Stand: März 2026',
    s1h2: '1. Datenschutz auf einen Blick',
    s1h3a: 'Allgemeine Hinweise',
    s1p1: 'Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.',
    s1h3b: 'Datenerfassung auf unserer Website',
    s1q1: 'Wer ist verantwortlich für die Datenerfassung auf dieser Website?',
    s1a1intro: 'Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber:',
    s1q2: 'Wie erfassen wir Ihre Daten?',
    s1a2: 'Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen – etwa durch das Ausfüllen unseres Kontaktformulars oder die Anmeldung zu unserem Newsletter. Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).',
    s1q3: 'Wofür nutzen wir Ihre Daten?',
    s1a3: 'Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden – sofern Sie dazu Ihre Einwilligung erteilt haben.',
    s1q4: 'Welche Rechte haben Sie bezüglich Ihrer Daten?',
    s1a4: 'Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen.',
    s1a4b:
      'Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden:',
    s2h2: '2. Hosting',
    s2p1: 'Unsere Website wird bei einem externen Dienstleister gehostet (Hoster). Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich v.a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und sonstige Daten handeln.',
    s2p2: 'Der Einsatz des Hosters erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und bestehenden Kunden und im Interesse einer sicheren, schnellen und effizienten Bereitstellung unseres Online-Angebots.',
    s3h2: '3. Allgemeine Hinweise und Pflichtinformationen',
    s3h3a: 'Datenschutz',
    s3p1: 'Der Betreiber dieser Seiten nimmt den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften – insbesondere der andorranischen Datenschutzgesetzgebung (LQPD – Llei Qualificada de Protecció de Dades, 18/2003) sowie der Europäischen Datenschutz-Grundverordnung (DSGVO/GDPR), soweit anwendbar.',
    s3h3b: 'Verantwortliche Stelle',
    s3p2: 'Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet.',
    s3h3c: 'Speicherdauer',
    s3p4: 'Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer personenbezogenen Daten haben.',
    s3h3d: 'Ihre Rechte',
    s3rights: [
      '<strong>Auskunftsrecht</strong> – Sie können Auskunft über Ihre bei uns gespeicherten Daten verlangen.',
      '<strong>Recht auf Berichtigung</strong> – Sie können die Berichtigung unrichtiger Daten verlangen.',
      '<strong>Recht auf Löschung</strong> – Sie können die Löschung Ihrer Daten verlangen ("Recht auf Vergessenwerden").',
      '<strong>Recht auf Einschränkung der Verarbeitung</strong> – Sie können die Einschränkung der Verarbeitung Ihrer Daten verlangen.',
      '<strong>Recht auf Datenübertragbarkeit</strong> – Sie können verlangen, dass wir Ihnen oder einem Dritten Ihre Daten in einem maschinenlesbaren Format übergeben.',
      '<strong>Widerspruchsrecht</strong> – Sie können der Verarbeitung Ihrer personenbezogenen Daten widersprechen.',
      '<strong>Widerrufsrecht</strong> – Sofern die Verarbeitung auf einer Einwilligung beruht, können Sie diese jederzeit widerrufen.',
    ],
    s3contact: 'Zur Ausübung dieser Rechte wenden Sie sich bitte an:',
    s4h2: '4. Datenerfassung auf unserer Website',
    s4h3a: 'Cookies',
    s4p1: 'Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die Ihr Webbrowser auf Ihrem Endgerät speichert. Cookies helfen uns dabei, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen.',
    s4types: 'Wir unterscheiden zwischen:',
    s4cookies: [
      '<strong>Technisch notwendige Cookies</strong> – Diese sind für den Betrieb der Website erforderlich und können nicht deaktiviert werden.',
      '<strong>Analyse-Cookies</strong> – Diese helfen uns zu verstehen, wie Besucher mit der Website interagieren. Sie werden nur nach Ihrer ausdrücklichen Einwilligung gesetzt.',
    ],
    s4p2: 'Beim ersten Besuch unserer Website werden Sie über ein Cookie-Banner um Ihre Einwilligung gebeten. Sie können Ihre Cookie-Einstellungen jederzeit anpassen oder alle nicht notwendigen Cookies ablehnen.',
    s4h3b: 'Server-Log-Dateien',
    s4logp:
      'Der Provider der Website erhebt und speichert automatisch Informationen in sogenannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:',
    s4logs: [
      'Browsertyp und Browserversion',
      'Verwendetes Betriebssystem',
      'Referrer URL',
      'Hostname des zugreifenden Rechners',
      'Uhrzeit der Serveranfrage',
      'IP-Adresse',
    ],
    s4logp2:
      'Diese Daten werden nicht mit anderen Datenquellen zusammengeführt. Die Erfassung dieser Daten erfolgt auf Grundlage berechtigter Interessen (Art. 6 Abs. 1 lit. f DSGVO) – der technisch fehlerfreie Betrieb der Website.',
    s4h3c: 'Kontaktformular',
    s4contactp1:
      'Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.',
    s4contactp2:
      'Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).',
    s4storedLabel: 'Gespeicherte Daten:',
    s4storedValue: 'Name, E-Mail-Adresse, Unternehmen/Projekt, Nachrichteninhalt',
    s4retentionLabel: 'Speicherdauer:',
    s4retentionValue: 'Bis zur abschließenden Bearbeitung Ihrer Anfrage, maximal 3 Jahre',
    s5h2: '5. Analyse-Tools',
    s5h3: 'Google Analytics',
    s5p1: 'Diese Website nutzt Google Analytics, einen Webanalysedienst der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland ("Google"). Google Analytics verwendet Cookies, die eine Analyse der Benutzung der Website durch Sie ermöglichen.',
    s5ipLabel: 'IP-Anonymisierung:',
    s5ipText:
      'Wir haben auf dieser Website die Funktion IP-Anonymisierung aktiviert. Dadurch wird Ihre IP-Adresse von Google innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum vor der Übermittlung in die USA gekürzt.',
    s5consent:
      'Google Analytics wird nur nach Ihrer ausdrücklichen Einwilligung über unser Cookie-Banner eingesetzt (Art. 6 Abs. 1 lit. a DSGVO).',
    s5contractLabel: 'Auftragsverarbeitungsvertrag:',
    s5contractText:
      'Wir haben mit Google einen Auftragsverarbeitungsvertrag abgeschlossen und setzen die strengen Vorgaben der Datenschutzbehörden bei der Nutzung von Google Analytics vollständig um.',
    s6h2: '6. Social Media',
    s6h3: 'Instagram',
    s6p1: 'Auf unserer Website sind Inhalte des sozialen Netzwerks Instagram eingebunden (Meta Platforms Ireland Limited, 4 Grand Canal Square, Dublin 2, Irland). Wenn Sie unsere Seite besuchen, kann durch die eingebundenen Instagram-Inhalte eine Verbindung zu den Servern von Instagram hergestellt werden.',
    s6p2: 'Die Einbindung von Instagram-Inhalten erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) oder auf Grundlage unseres berechtigten Interesses an einer ansprechenden Darstellung unseres Online-Angebots (Art. 6 Abs. 1 lit. f DSGVO).',
    s7h2: '7. Newsletter',
    s7p1: 'Wenn Sie den auf der Website angebotenen Newsletter beziehen möchten, benötigen wir von Ihnen eine E-Mail-Adresse sowie Informationen, welche uns die Überprüfung gestatten, dass Sie der Inhaber der angegebenen E-Mail-Adresse sind und mit dem Empfang des Newsletters einverstanden sind (Double-Opt-In-Verfahren).',
    s7storedLabel: 'Gespeicherte Daten:',
    s7storedValue: 'E-Mail-Adresse, Vorname (optional), Datum der Anmeldung',
    s7purposeLabel: 'Zweck:',
    s7purposeValue: 'Versand des Newsletters',
    s7legalLabel: 'Rechtsgrundlage:',
    s7legalValue: 'Einwilligung (Art. 6 Abs. 1 lit. a DSGVO)',
    s7unsubscribe:
      'Sie können den Newsletter jederzeit über den Abmeldelink im Newsletter oder durch eine E-Mail an hi@buenas-studio.com abbestellen.',
    s8h2: '8. Plugins und Tools',
    s8h3: 'Google Fonts',
    s8p1: 'Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten sogenannte Web Fonts, die von Google bereitgestellt werden. Beim Aufruf einer Seite lädt Ihr Browser die benötigten Web Fonts in Ihren Browsercache, um Texte und Schriftarten korrekt anzuzeigen.',
    s8p2: 'Die Nutzung von Google Web Fonts erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an der einheitlichen Darstellung des Schriftbildes auf unserer Website.',
    s9h2: '9. Änderungen dieser Datenschutzerklärung',
    s9p: 'Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen.',
    s10h2: '10. Kontakt bei Datenschutzfragen',
    footernote: 'Buenas Studio · buenas-studio.com · hi@buenas-studio.com · Stand: März 2026',
  },
  footer: {
    subtitle: 'Studio für Design & Text',
    tagline: 'good. better. buenas.',
    locations: 'Andorra · Austria · World',
    copyright: '© 2026 Buenas Studio',
    link1: 'Impressum',
    link2: 'Datenschutz',
  },
  whatsapp: {
    greeting: 'Buenas!',
    text: 'Wie können wir dir helfen? Schreib uns gerne!',
    send: 'Nachricht senden →',
    prefill: 'Hola! Ich habe eine Idee...',
  },
  seo: {
    home: {
      title: 'buenas studio – Studio für Design, Text & Software',
      description:
        'Design, Text und Software-Entwicklung aus Andorra und Bodensee. Corporate Design, Branding, Texte, Websites und individuelle Software – kreativ und professionell.',
    },
    legal: {
      title: 'Impressum – buenas studio',
      description:
        'Impressum und rechtliche Informationen von buenas studio. Christina Mathis – Marketing & IT Services, Encamp, Andorra.',
    },
    privacy: {
      title: 'Datenschutz – buenas studio',
      description:
        'Datenschutzerklärung von buenas studio. Informationen zur Erhebung und Verarbeitung personenbezogener Daten.',
    },
    thanks: {
      title: 'Danke – buenas studio',
      description: 'Danke für deine Nachricht! Wir melden uns so schnell wie möglich.',
    },
    notFound: {
      title: 'Seite nicht gefunden – buenas studio',
      description:
        'Diese Seite existiert leider nicht. Geh zurück zur Startseite von buenas studio.',
      h1: 'Seite nicht gefunden',
      text: 'Ups – diese Seite gibt es leider nicht.',
      back: '← Zurück zur Startseite',
    },
  },
}

export default de
